import { Dropdown } from "react-bootstrap";
import { Customer } from "../utils/customerTypes";
import ActionIco from "../../../../assets/action.png";

interface CustomerListItemProps {
  customer: Customer;
  onView: (customerId: string) => void;
  onEdit: (customerId: string) => void;
  onSuspend: (customerId: string) => void;
  onActivate: (customerId: string) => void;
}

const CustomerListItem: React.FC<CustomerListItemProps> = ({
  customer,
  onView,
  onEdit,
  onSuspend,
  onActivate,
}) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "N/A";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <tr className="customer-row">
      <td className="customer-name-cell">
        <div className="customer-name-wrapper">
          <input
            type="checkbox"
            className="name-checkbox"
            onClick={(e) => e.stopPropagation()}
          />
          <div className="customer-avatar-placeholder">
            {customer.firstName.charAt(0)}
            {customer.lastName.charAt(0)}
          </div>
          <span className="customer-name" onClick={() => onView(customer.id)}>
            {customer.firstName} {customer.lastName}
          </span>
        </div>
      </td>
      <td className="customer-address-cell" data-label="Address">
        {[customer.city, customer.province, customer.postCode]
          .filter(Boolean)
          .join(", ") ||
          customer.address ||
          "N/A"}
      </td>
      <td className="customer-spend-cell" data-label="Stores">
        {customer.storeCount ?? 0}
      </td>
      <td className="customer-rating-cell" data-label="Status">
        <span className="rating-value">{customer.status || "N/A"}</span>
      </td>
      <td className="customer-email-cell" data-label="Email">
        {customer.email || "N/A"}
      </td>
      <td className="customer-date-cell" data-label="Created on">
        <div className="date-wrapper">
          <span>{formatDate(customer.createdDate)}</span>
          <Dropdown className="report_dropdown">
            <Dropdown.Toggle id="dropdown-basic" className="action-cta">
              <div className="action">
                <img src={ActionIco} alt="" />
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => onView(customer.id)}>
                Open customer
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </td>
    </tr>
  );
};

export default CustomerListItem;
